import { ReactElement } from 'react';
import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames';

import { SearchMenu } from '@gn-audio/jss-components';
import SearchProvider from '@gn-audio/jss-components/components/Search/providers/SearchProvider';

import { SearchMenuFields } from 'common/types/search';
import { ComponentProps } from 'lib/component-props';

type SearchProps = ComponentProps & {
  fields: SearchMenuFields;
  dropdown?: boolean;
  props: StaticProps;
};

type StaticProps = {
  [name: string]: string;
};

const Search = (searchProps: SearchProps): ReactElement => {
  return (
    <div
      className={classNames(
        'bg-succes relative z-20 w-full origin-top-right',
        searchProps.dropdown ? '' : 'min-h-24'
      )}
    >
      <SearchProvider>
        <SearchMenu menuItem={searchProps.fields} isMenuOpened={searchProps.dropdown} />
      </SearchProvider>
    </div>
  );
};

export default withDatasourceCheck()<SearchProps>(Search);

export async function getStaticProps() {
  return {
    props: { productCatalogueBaseUrl: process.env.PRODUCT_CATALOGUE_BASE_URL },
  };
}
